import { Container } from "../../UI/container/Container";
import { MyH1 } from "../../UI/my-h1/MyH1";
import { useColors } from "../../../hooks/colors/useColors";
import { PageHeader } from "../page-header/PageHeader";
import { SpecialistDataProps } from "../../../hooks/react-query/useSpecialist";
import { IconArrowNarrowRight, IconCalendarEvent } from "@tabler/icons";
import { SpecialistInfo } from "./SpecialistInfo";
import { useTranslation } from "next-i18next";
import { ContentVisualizer } from "../content-visualizer/ContentVisualizer";
import { ButtonLink } from "../../UI/button-link/ButtonLink";
import { isMobile } from "react-device-detect";
import Link from "next/link";
import { Fragment, useState } from "react";
import { Post } from "../../../types/graphql";
import useAsyncEffect from "use-async-effect";
import {
  filterBlogsByAuthor,
  // getAllAuthors,
} from "../../../services/fetch-data/blogUtil";
import { useRouter } from "next/router";
import { Grid } from "@mantine/core";
import { BlogCard } from "../homepage/blog/BlogCard";
import { Footer } from "../homepage/footer/Footer";
import { BlogData, useBlogList } from "../../../hooks/react-query/useBlogList";

export function SpecialistPage(props: SpecialistDataProps) {
  const { specialist } = props;
  const { colors } = useColors();
  const { i18n } = useTranslation("common");
  const router = useRouter();
  // const [blogs, setBlogs] = useState<BlogData[]>();
  const [authorSlug, setAuthorSlug] = useState<string | undefined>();
  const { blogs, comparePosts, getFirstNArticles } = useBlogList();

  // useAsyncEffect(async () => {
  //   try {
  //     // const blogAuthors = await getAllAuthors();
  //     // const blogAuthorSlug = blogAuthors.data.users.edges.filter(
  //     //   (author) =>
  //     //     author.node.slug &&
  //     //     specialist.urlSlug
  //     //       .toLowerCase()
  //     //       .replaceAll("-", "")
  //     //       .includes(author.node.slug.toLowerCase().replaceAll("-", ""))
  //     // )[0]?.node.slug;
  //
  //     // if (blogAuthorSlug) setAuthorSlug(blogAuthorSlug);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }, [specialist]);

  useAsyncEffect(async () => {
    if (router.locale && blogs) {
      const blogData = await filterBlogsByAuthor(blogs, specialist.urlSlug);
      console.log(blogData);

      // if (blogs)
      //   setBlogs(
      //     // @ts-ignore
      //     blogs.data.users.edges[0].node!.posts.nodes
      //   );
    }
  }, [router.locale, specialist]);

  return (
    <Fragment>
      <PageHeader>
        <MyH1
          size={isMobile ? "1.8rem" : "2.6rem"}
          className="text-center"
          color="white"
        >
          {specialist.name}
        </MyH1>
      </PageHeader>
      <Container noHeight>
        <SpecialistInfo specialist={specialist} />
        <ContentVisualizer content={specialist.content} />
        <div className="flex justify-center my-10">
          <ButtonLink
            className="w-[300px] h-[50px]"
            href="/agendar"
            uppercase
            color={colors.secondary}
            title={i18n.t("book-app")}
            icon={<IconCalendarEvent color={colors.white} />}
            rounded
          />
        </div>
        {authorSlug && (
          <div>
            {blogs && (
              <Grid>
                <Grid.Col span={12}>
                  <h2
                    style={{ color: colors.primary }}
                    className="text-center mt-6 text-4xl"
                  >
                    {i18n.t("blog.some-entries")}
                  </h2>
                </Grid.Col>
                {Object.keys(getFirstNArticles(blogs, 3)).map((key, index) => {
                  const blogPost = blogs[key];
                  return <BlogCard key={index} slug={key} data={blogPost} />;
                })}
              </Grid>
            )}
            <div className="flex justify-center w-full">
              <Link
                href={`/blog/autor/${authorSlug}`}
                className="hover:cursor-pointer text-center"
              >
                <div className="text-center p-4">
                  <div
                    style={{ color: colors.secondary }}
                    className="text-center font-bold text-2xl p-2 hover flex items-center"
                  >
                    <span>{i18n.t("blog.all-entries")}</span>
                    <IconArrowNarrowRight
                      size="2rem"
                      color={colors.secondary}
                    />
                  </div>
                </div>
              </Link>
            </div>
          </div>
        )}
      </Container>
      <Footer isVisible delay />
    </Fragment>
  );
}
